import { render, staticRenderFns } from "./QuestionsComponentList.vue?vue&type=template&id=0b6b5028"
import script from "./QuestionsComponentList.vue?vue&type=script&lang=js"
export * from "./QuestionsComponentList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports